import {
  AddDocsResponse,
  DeleteDocResponse,
} from 'app/modules/entities/responses';

import { destroy, post, upload } from 'app/shared/utils/fetchr';
import { AddGDriveDocsPayload } from 'app/modules/entities/requests';

export const addS3Docs = (
  externalId: string,
  files: File[],
): Promise<AddDocsResponse> => {
  const payload = new FormData();
  files.forEach((i, idx) => {
    payload.append(`file${idx}`, i);
  });
  return upload(
    `/v1/entities/${encodeURIComponent(externalId)}/add-files-by-external-id`,
    payload,
  );
};

export const addGDriveDocs = (
  externalId: string,
  payload: AddGDriveDocsPayload,
): Promise<AddDocsResponse> => {
  return post(
    `/v1/entities/${encodeURIComponent(externalId)}/attachment/add-by-external-id`,
    payload,
  );
};

export const deleteDocument = (
  externalId: string,
  docID: number,
): Promise<DeleteDocResponse> => {
  return destroy(
    `/v1/entities/${encodeURIComponent(externalId)}/attachment/${encodeURIComponent(docID)}/delete-by-external-id`,
  );
};

// Hashed-id (cached) variants. Used when the `CM_DELTA_LAKE_HASHED_ID_ROUTES` flag is on
// so external_ids never appear in URL paths.
export const addS3DocsByHashedId = (
  hashedId: string,
  files: File[],
): Promise<AddDocsResponse> => {
  const payload = new FormData();
  files.forEach((i, idx) => {
    payload.append(`file${idx}`, i);
  });
  return upload(`/v1/entities/cached/${hashedId}/add-files`, payload);
};

export const addGDriveDocsByHashedId = (
  hashedId: string,
  payload: AddGDriveDocsPayload,
): Promise<AddDocsResponse> => {
  return post(`/v1/entities/cached/${hashedId}/attachment/add`, payload);
};

export const deleteDocumentByHashedId = (
  hashedId: string,
  docID: number,
): Promise<DeleteDocResponse> => {
  return destroy(
    `/v1/entities/cached/${hashedId}/attachment/${encodeURIComponent(docID)}/delete`,
  );
};
